export enum PinCodeValidationActionTypes {
  INPUT_VALUES = 'INPUT_VALUES',
  COUNTER_RESET = 'COUNTER_RESET',
  PINCODE_SUBMIT = 'PINCODE_SUBMIT',
  RESET_STATE = 'PINCODE_RESET_STATE',
  COUNTER_DECREMENT = 'COUNTER_DECREMENT',
}

interface PinCodeValidationInputValues {
  type: PinCodeValidationActionTypes.INPUT_VALUES;
  values: string[];
}

interface PinCodeValidationSubmit {
  type: PinCodeValidationActionTypes.PINCODE_SUBMIT;
  values: string[];
  errorMessage: string | null;
}

interface PinCodeValidationResetState {
  type: PinCodeValidationActionTypes.RESET_STATE;
}

interface PinCodeValidationCounterReset {
  type: PinCodeValidationActionTypes.COUNTER_RESET;
}

interface PinCodeValidationCounterDecrement {
  type: PinCodeValidationActionTypes.COUNTER_DECREMENT;
}

export function resetState(): PinCodeValidationResetState {
  return {
    type: PinCodeValidationActionTypes.RESET_STATE,
  };
}

export function setValues(values: string[]): PinCodeValidationInputValues {
  return {
    type: PinCodeValidationActionTypes.INPUT_VALUES,
    values,
  };
}

export function setPinCodeSubmit(values: string[], errorMessage: string | null): PinCodeValidationSubmit {
  return {
    type: PinCodeValidationActionTypes.PINCODE_SUBMIT,
    values,
    errorMessage,
  };
}

export function setCounterReset(): PinCodeValidationCounterReset {
  return {
    type: PinCodeValidationActionTypes.COUNTER_RESET,
  };
}

export function setCounterDecrement(): PinCodeValidationCounterDecrement {
  return {
    type: PinCodeValidationActionTypes.COUNTER_DECREMENT,
  };
}

export type PinCodeValidationActions =
  | PinCodeValidationInputValues
  | PinCodeValidationSubmit
  | PinCodeValidationResetState
  | PinCodeValidationCounterReset
  | PinCodeValidationCounterDecrement;
